import './hours.css';

const HOURS = [
  { day: "Sunday",    abbr: "SUN", hours: "Closed" },
  { day: "Monday",    abbr: "MON", hours: "Closed" },
  { day: "Tuesday",   abbr: "TUE", hours: "10:00 AM – 7:00 PM" },
  { day: "Wednesday", abbr: "WED", hours: "Closed" },
  { day: "Thursday",  abbr: "THU", hours: "9:00 AM – 7:00 PM" },
  { day: "Friday",    abbr: "FRI", hours: "9:00 AM – 7:00 PM" },
  { day: "Saturday",  abbr: "SAT", hours: "10:00 AM – 3:00 PM" },
];

export default function Hours() {
  const today = new Date().getDay();

  return (
    <section className="hours" id="hours">
      <div className="hours-inner">

        {/* ── Left panel ── */}
        <div className="hours-left">
          <div className="hours-eyebrow">
            <span className="hours-eyebrow-dot" />
            <span>Studio</span>
          </div>

          <h2 className="hours-heading">Hours</h2>

          <div className="hours-divider" />

          <p className="hours-sub">
            Schedule your next appointment<br />with me! 
          </p>
          <a
            href="https://www.vagaro.com/hairbykatheryne"
            target="_blank"
            rel="noopener noreferrer"
            className="hours-book-btn"
          >
            <span>Book Appointment</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>

        {/* ── Right panel ── */}
        <div className="hours-right">
          {HOURS.map((item, i) => {
            const isToday = i === today;
            const isClosed = item.hours === "Closed";

            return (
              <div
                key={item.day}
                className={`hours-row${isToday ? " is-today" : ""}${isClosed ? " is-closed" : ""}`}
                style={{ animationDelay: `${i * 0.065}s` }}
              >
                <div className="hours-row-left">
                  <span className="hours-abbr">{item.abbr}</span>
                  <span className="hours-dayname">{item.day}</span>
                  {isToday && <span className="hours-today-badge">Today</span>}
                </div>
                <span className="hours-time">{item.hours}</span>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
